// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__OlMVx","list":"BalanceDue_list__FCD1j","listRow":"BalanceDue_listRow__16O2L","total":"BalanceDue_total__3FDRu"};